<div [ngClass]="!mode ? 'example-wrapper' : 'outer-example-wrapper'">
  <div class="hooxpay-example">
    <img src="assets/images/checkout-extensions/hooxpay.jpeg" class="hooxpay-example__image" />
  </div>
</div>
